const translations = {
    es: {
        // Page titles and labels
        "page.title": "Gestión de usuarios",

        // Alert messages
        "alerts.error": "Error!",
        "alerts.noUserSelected": "No se ha seleccionado ningún usuario.",
        "alerts.confirmDelete": "Confirme el borrado",
        "alerts.selectedUsers": "De los usuarios seleccionados",
        "alerts.serverError": "Error en el servidor. Avise al administrador",

        // User properties
        "user.username": "Nombre de usuario",
        "user.firstName": "Nombre",
        "user.lastName": "Apellidos",
        "user.email": "Correo electrónico",
        "user.password": "Contraseña",
        "user.confirmPassword": "Confirmar contraseña",
        "user.organization": "Organización",
        "user.panel": "Panel",
        "user.isSuperuser": "Superusuario",
        "user.isStaff": "Miembro del personal",
        "user.isActive": "Activo",
        "user.lastLogin": "Último acceso",
        "user.dateJoined": "Fecha de registro",
        "user.phone1": "Teléfono 1",
        "user.phone2": "Teléfono 2",
        "user.language": "Idioma",
        "user.accessOrganizations": "Organizaciones a las que puede acceder",
        "user.accessPanels": "Municipios a los que puede acceder",
        "user.userRole": "Rol del usuario",
        "user.Alerts": "Alertas de usuario",
        "user.isAdmin": "Administrador",
        "user.isTech": "Técnico",
        "user.isMaint": "Mantenimiento",
        "user.isDriver": "Conductor",
        "user.isFireman": "Alerta de incendio",
        "user.isViewer": "Visualiza",
        "user.isReport": "Informes",
        "user.receiveEmails": "Recibir correos",
        "user.alarms": "Alarmas",
        "user.emailInvitation": "Se enviará un correo electrónico con la invitación.",
        "user.createUser": "Crear usuario",
        "user.selectOrg": "Se debe de seleccionar alguna organización.",
        "user.selectPanel": "Debe de tener algún Panel activo.",
        "user.errorSelectOrg": "Hay que seleccionar una organización.",
        "user.errorSelectPanel": "Hay que seleccionar un municipio.",
        "user.errorSelectRole": "No se ha seleccionado ningún ROL.",
        "user.formErrors": "Errores en el formulario",
        "user.saveError": "Error al guardar",

        // User dates preview
        "user.created": "Creado",
        "user.updated": "Actualizado",
        "user.confirmed": "Confirmado",
        "user.passwordChanged": "Cambio Contraseña",
        "user.lastChangeRequest": "Última solicitud de cambio",
        "user.blocked": "Bloqueado",

        // Button labels
        "buttons.accept": "Aceptar",
        "buttons.cancel": "Cancelar",
        "buttons.delete": "Eliminar",
        "buttons.save": "Guardar",
        "buttons.edit": "Editar",
    },
    en: {
        // Page titles and labels
        "page.title": "User Management",

        // Alert messages
        "alerts.error": "Error!",
        "alerts.noUserSelected": "No user has been selected.",
        "alerts.confirmDelete": "Confirm deletion",
        "alerts.selectedUsers": "Of the selected users",
        "alerts.serverError": "Server error. Please notify the administrator",

        // User properties
        "user.username": "Username",
        "user.firstName": "First Name",
        "user.lastName": "Last Name",
        "user.email": "Email",
        "user.password": "Password",
        "user.confirmPassword": "Confirm Password",
        "user.organization": "Organization",
        "user.panel": "Panel",
        "user.isSuperuser": "Superuser",
        "user.isStaff": "Staff Member",
        "user.isActive": "Active",
        "user.lastLogin": "Last Login",
        "user.dateJoined": "Date Joined",
        "user.phone1": "Phone 1",
        "user.phone2": "Phone 2",
        "user.language": "Language",
        "user.accessOrganizations": "Organizations that can be accessed",
        "user.accessPanels": "Municipalities that can be accessed",
        "user.userRole": "User Role",
        "user.Alerts": "User Alerts",
        "user.isAdmin": "Administrator",
        "user.isTech": "Technician",
        "user.isMaint": "Maintenance",
        "user.isDriver": "Driver",
        "user.isFireman": "Fire alerts",
        "user.isViewer": "Can view",
        "user.isReport": "Reports",
        "user.receiveEmails": "Receive emails",
        "user.alarms": "Alarms",
        "user.emailInvitation": "An email with the invitation will be sent.",
        "user.createUser": "Create user",
        "user.selectOrg": "You must select an organization.",
        "user.selectPanel": "You must have an active Panel.",
        "user.errorSelectOrg": "You must select an organization.",
        "user.errorSelectPanel": "You must select a municipality.",
        "user.errorSelectRole": "No ROLE has been selected.",
        "user.formErrors": "Form errors",
        "user.saveError": "Error saving",

        // User dates preview
        "user.created": "Created",
        "user.updated": "Updated",
        "user.confirmed": "Confirmed",
        "user.passwordChanged": "Password Changed",
        "user.lastChangeRequest": "Last Change Request",
        "user.blocked": "Blocked",

        // Button labels
        "buttons.accept": "Accept",
        "buttons.cancel": "Cancel",
        "buttons.delete": "Delete",
        "buttons.save": "Save",
        "buttons.edit": "Edit",
    },
};

export default translations;
